<nz-select
    [(ngModel)]="selectTemplateId"
    [ngModelOptions]="{standalone: true}"
    (nzScrollToBottom)="loadMore()"
    (nzOpenChange)="openChange($event)"
    (ngModelChange)="changeSelect()"
    nzPlaceHolder="Select template"
    nzAllowClear
    [nzDropdownRender]="renderTemplate"
>
    <nz-option *ngFor="let item of resourceTemplateOptions" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
</nz-select>
<ng-template #renderTemplate>
    <nz-spin *ngIf="isLoading"></nz-spin>
</ng-template>
